import { withDashboardLayout } from 'layouts/DashboardLayout/DashboardLayout';
import {useState } from 'react';
import PageContainer from 'components/PageContainer/PageContainer';
import { Card } from 'semantic-ui-react';

import ReprintLabelForm from 'components/ReprintLabelForm/ReprintLabelForm';

function LabelsPage() {
  const [isPrinting, setIsPrinting] = useState(false);



  return (
    <PageContainer title="Reimprimir Etiquetas" className="labels-page">
       <>
        <Card.Header>
        <ReprintLabelForm isPrinting={isPrinting} setIsPrinting={setIsPrinting} />

        </Card.Header>
        
      </>
    </PageContainer>
  );
}

export default withDashboardLayout(LabelsPage);
